
import {
    Box, Stack, Typography, IconButton, CircularProgress, Alert,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

import CardShell from "../components/CardShell";
import { useMissingEmployees } from "../hooks/useLiquidacionData";


function Pill({ children, sx }) {
    return (
        <Box
            sx={{
                px: 2.5,
                py: 1.1,
                bgcolor: "secondary.50",
                borderRadius: "33px",
                boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}

function minutesToHours(minutes) {
    if (!minutes) return '0h';
    const h = Math.floor(Number(minutes) / 60);
    const m = Number(minutes) % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
}
function formatDateRange(start, end) {
    if (!start || !end) return '—';

    const formatStringDate = (val) => {
        const pureDate = String(val).split('T')[0];
        const [year, month, day] = pureDate.split('-');
        return `${day}/${month}/${year}`;
    };

    return `${formatStringDate(start)} - ${formatStringDate(end)}`;
}

const GRID_COLS = 'minmax(200px, 2fr) minmax(180px, 1.5fr) minmax(150px, 1.5fr) minmax(180px, 1.5fr)';

function ColHeader({ children, sx }) {
    return (
        <Box sx={{ px: 1, py: 1, bgcolor: 'secondary.200', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
            <Typography sx={{ fontSize: 13, textAlign: 'center', fontWeight: 700, color: 'primary.900' }}>
                {children}
            </Typography>
        </Box>
    );
}

export default function MissingClosuresPage() {
    const navigate = useNavigate();
    const { missing, loading, error: fetchError } = useMissingEmployees();



    return (
        <Box sx={{ p: 2, height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column', gap: 2, overflow: 'hidden' }}>

            {/* HEADER */}
            <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                <IconButton
                    onClick={() => navigate("/rrhh/liquidacion")}
                    sx={{ width: 40, height: 40, bgcolor: "secondary.500", "&:hover": { bgcolor: "secondary.600" } }}
                >
                    <ArrowBackIcon sx={{ color: "logoblanco", fontSize: 32 }} />
                </IconButton>

                <Stack sx={{ flex: 1, alignItems: "center", pr: "48px" }}>
                    <Pill sx={{ bgcolor: "secondary.200" }}>
                        <Typography sx={{ fontSize: 18, fontWeight: 600, color: "primary.900" }}>
                            Cierres Faltantes
                        </Typography>
                    </Pill>
                </Stack>

            </Stack>

            {fetchError && <Alert severity="error">{fetchError}</Alert>}

            {/* TABLA DE FALTANTES */}
            <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", bgcolor: "#A9A9B6", borderRadius: "24px", p: 2, overflow: "hidden" }}>
                <CardShell sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", p: 2 }}>

                    <Box sx={{ display: 'grid', gridTemplateColumns: GRID_COLS, gap: 1.5, px: 1.5, pb: 1.5, flexShrink: 0 }}>
                        <ColHeader sx={{ textAlign: 'center' }}>Empleado</ColHeader>
                        <ColHeader sx={{ textAlign: 'center' }}>Horas Trabajadas</ColHeader>
                        <ColHeader sx={{ textAlign: 'center' }}>Cierre Original</ColHeader>
                        <ColHeader sx={{ textAlign: 'center' }}>Período</ColHeader>
                    </Box>

                    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', pr: 1 }}>
                        {loading ? (
                            <Stack spacing={2} sx={{ alignItems: 'center', py: 8 }}>
                                <CircularProgress size={40} color="primary" />
                            </Stack>
                        ) : missing.length === 0 ? (
                            <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'neutral.700', textAlign: 'center', py: 8 }}>
                                ¡Todo al día! No hay empleados faltantes por liquidar.
                            </Typography>
                        ) : (
                            <Stack spacing={1}>
                                {missing.map((item) => (
                                    <Box
                                        key={item.id}
                                        sx={{
                                            display: 'grid', gridTemplateColumns: GRID_COLS, alignItems: 'center', gap: 1.5, px: 2, py: 1,
                                            bgcolor: 'neutral.50',
                                            borderRadius: '16px', border: '1px solid',
                                        }}
                                    >
                                        <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'primary.900' }}>
                                            {item.fullNameSnapshot}
                                        </Typography>
                                        <Box sx={{ display: 'flex', px: 1.5, py: 0.5, bgcolor: '#ffecb3', borderRadius: '12px', width: 'fit-content', margin: '0 auto', textAlign: 'center' }}>
                                            <Typography sx={{ fontSize: 13, fontWeight: 800, color: '#f57f17', textAlign: 'center' }}>
                                                {minutesToHours(item.workedMinutesSnapshot)}
                                            </Typography>
                                        </Box>
                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'primary.700', fontStyle: 'italic', textAlign: 'center', }}>
                                            {item.sourceClosure?.name || 'Cierre desconocido'}
                                        </Typography>
                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'primary.700', textAlign: 'center', }}>
                                            {formatDateRange(item.periodStart, item.periodEnd)}
                                        </Typography>

                                    </Box>
                                ))}
                            </Stack>
                        )}
                    </Box>
                </CardShell>
            </Box>
        </Box>
    );
}